<template>
	<div v-if="showNoDataImgForUser">
		<div class="progressImgDataContainer">
			<div class="progressDataText">
				<h4>Your data has been successfully added to Weavr!</h4>
				<p>Please check back in 24 hours.</p>
			</div>
			<div class="progressImgWrapper">
				<img src="Icons_SVG/progressDataImgUpdated.svg" alt="data in progress" />
			</div>
		</div>
	</div>
	<div v-else>
		<div v-if="loader || loaderStatus">
			<Loader />
		</div>
		<div class="row datepickerwrap card">
			<div class="d-flex justify-content-between">
				<div class="d-flex align-items-center" style="">
					<!-- <div class="datebox">
                    <datepicker placeholder="Select Start Date" v-model="startDate" :disabled="disabledDates" />
                </div>
                <div class="datebox">
                    <datepicker placeholder="Select End Date" v-model="endDate" :disabled="disabledDates" />
                </div> -->
					<div>
						<div class="ml-2" style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
                margin-bottom: 2px;
              ">
			  {{ translatedLang["Date Range"][selectedLanguage.key] }}
						</div>
						<date-range-picker v-model="dateRange" opens="right" :autoApply="true"
							:locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate"
							class="date-range-control">
						</date-range-picker>
					</div>
					<div class="customMultiselectCommon mr-2" style="width: 165px">
						<div class="mb-1" style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              ">
			  {{ translatedLang["Platform"][selectedLanguage.key] }}
						</div>
						<!-- <select
              id="platform"
              class="form-control text-capitalize"
              v-model="selectedChannel"
            >
              <option
                v-for="channel of channelsList"
                :key="channel"
                :value="channel"
                class="text-capitalize"
              >
                {{ channel.replace('_', ' ') }}
              </option>
            </select> -->
						<multiselect v-model="selectedChannel" class="text-capitalize" :options="channelsList"
							:custom-label="updateSelectedLabels" :multiple="false" :searchable="false"
							placeholder="Select Category" :showLabels="false" :close-on-select="true"
							:allow-empty="false">
							<template #option="{ option }">
								<div class="custom-option text-capitalize">
									{{ option.replace('_', ' ') }}
								</div>
							</template>
						</multiselect>
					</div>

					<div class="customMultiselectCommon mr-1" style="width: 170px">
						<div class="mb-1" style="
                font-size: 13px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              ">
			  {{ translatedLang["Category"][selectedLanguage.key] }}
						</div>
						<!-- <select
              @change="updateCategory"
              id="platform"
              class="form-control text-capitalize"
              v-model="selectedCategory"
            >
              <option
                v-for="category of categoriesList[selectedChannel]"
                :key="category.key"
                :value="category.key"
                class="text-capitalize"
              >
                {{ category.value }}
              </option>
            </select> -->
						<multiselect @input="updateCategory" v-model="selectedCategory" class="text-capitalize"
							:options="categoriesList[selectedChannel]" :multiple="false" :searchable="false"
							placeholder="Select Category" :showLabels="false" :close-on-select="true"
							:allow-empty="false" track-by="key" label="value">
						</multiselect>
					</div>
					<div class="customMultiselect ml-1 mr-2 align-items-center">
						<div class="mb-1" style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              ">
			  {{ translatedLang["Products"][selectedLanguage.key] }}
						</div>
						<multiselect v-model="selectedProducts"
							:options="productsList[selectedChannel][selectedCategory.key] || []" :multiple="true"
							:searchable="false" track-by="name" label="name" placeholder="Select Products to filter"
							selectLabel="" deselectLabel="Remove" @select="selectProduct" @remove="removeProduct"
							:close-on-select="false">
							<template slot="option" slot-scope="{ option }">
								<input type="checkbox" :value="option" v-model="selectedProducts" />
								<span class="option__title ml-3">{{ option.name }}</span>
							</template>
						</multiselect>
					</div>
					<div class="d-flex mb-1">
						<div>
							<span class="mb-1" style="
                  font-size: 14px;
                  font-weight: 400;
                  color: rgba(30, 30, 30, 1);
                ">{{ translatedLang["Rating"][selectedLanguage.key] }}
							</span>
							<select id="start-rating" v-model="leastRating"
								class="form-control text-uppercase star-select mt-1" data-display="☆☆☆☆☆">
								<option value="1">&#11088;</option>
								<option value="2">&#11088;&#11088;</option>
								<option value="3">&#11088;&#11088;&#11088;</option>
								<option value="4">&#11088;&#11088;&#11088;&#11088;</option>
								<option value="5">
									&#11088;&#11088;&#11088;&#11088;&#11088;
								</option>
							</select>
						</div>
						<span class="ml-2" style="margin-top: 30px"> - </span>
					</div>

					<div class="ml-2">
						<select id="end-rating" v-model="maxRating" style="margin-top: 22px;"
							class="form-control text-uppercase star-select" data-display="☆☆☆☆☆">
							<option value="1">&#11088;</option>
							<option value="2">&#11088; &#11088;</option>
							<option value="3">&#11088;&#11088;&#11088;</option>
							<option value="4">&#11088;&#11088;&#11088;&#11088;</option>
							<option value="5">
								&#11088;&#11088;&#11088;&#11088;&#11088;
							</option>
						</select>
					</div>
					<div class="ml-2 mb-1">
						<div class="mb-1" style="
                font-size: 14px;
                font-weight: 400;
                color: rgba(30, 30, 30, 1);
              ">
			  {{ translatedLang["Keyword"][selectedLanguage.key] }}
						</div>
						<input class="form-control" type="text" v-model="selectedKeyword"
							placeholder="Enter a keyword..." />
					</div>
				</div>
				<div class="ml-3" style="margin-top: 25px">
					<button class="btn primarycolor py-2" @click="getWordTreeData">
						{{ translatedLang["submit"][selectedLanguage.key] }}
					</button>
				</div>
			</div>
		</div>
		<div class="card" style="margin: 10px">
			<GChart v-if="chartData.length" @ready="onChartReady" type="WordTree" :options="chartOptions"
				:data="chartData" :settings="chartSettings" />
			<div v-show="!chartData.length" class="no-data">
				{{
					!selectedProducts.length || !selectedKeyword
						? `${ translatedLang["Provide products and keyword to get the phrase analysis"][selectedLanguage.key]}`
						: `${ translatedLang["No Data"][selectedLanguage.key]}`
				}}
			</div>
			<div class="d-flex justify-content-end" style="gap: 4px; list-style: none"
				v-if="chartData.length && pagesArr.length > 1">
				<button class="pagination-button" title="Previous" @click="setPreviousPage"
					:disabled="currentPage === pagesArr[0]"></button>
				<span v-for="page in visiblePages" :key="page">
					<button v-if="page" @click="setCurrentPageData(page)" class="pagination-button"
						:class="{ active: currentPage === page }">
						{{ page }}
					</button>
					<span v-else>...</span>
				</span>
				<button class="pagination-button" title="Next" @click="setNextPage"
					:disabled="currentPage === pagesArr[pagesArr.length - 1]">
					>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { GChart } from "vue-google-charts/legacy";
import Loader from "../Components/Loader.vue";
import { mapState, mapActions } from "vuex";
export default {
	name: "PhraseAnalyser",
	components: {
		Loader,
		Multiselect,
		Datepicker,
		GChart,
	},
	data() {
		return {
			loader: false,
			dateRange: {
				startDate: moment("2017-01-01").format("YYYY-MM-DD"),
				endDate: moment().format("YYYY-MM-DD"),
			},
			maxDate: new Date(),
			minDate: new Date(moment("2017-01-01")),
			channelsList: [],
			selectedChannel: "",
			categoriesList: [],
			selectedCategory: "",
			productsList: {},
			leastRating: "1",
			maxRating: "5",
			selectedKeyword: "",
			selectedProducts: [],
			disabledDates: {
				// to: new Date("2024-03-30"),
				from: new Date("2017-01-01"),
			},
			client: JSON.parse(localStorage.reviewUserData).data.client,
			chartOptions: {
				wordtree: {
					format: "implicit",
					type: "double",
					word: "",
				},
				maxFontSize: 26,
			},
			chartSettings: {
				packages: ["wordtree"],
			},
			chartData: [],
			rawData: [],
			columnsPerPage: 20,
			numberOfPages: 0,
			pagesArr: [],
			currentPage: 1,
			storeAllDataForStatus: {},
			loaderStatus: false,
			showNoDataImgForUser: false
		};
	},
	mounted() {
		this.$store.dispatch("DemoStore/setTimeStamp", "");
		this.getAllStatusByApi();
	},
	watch: {
		selectedCategory: function () {
			if (Object.keys(this.storeAllDataForStatus).length) {
				this.$store.dispatch("DemoStore/setUpdatedStatus", this.storeAllDataForStatus[this.selectedChannel][this.selectedCategory.key])
			} else {
				this.$store.dispatch("DemoStore/setUpdatedStatus", '')
			}
		},
		selectedChannel: function () {
			if (Object.keys(this.storeAllDataForStatus).length) {
				this.$store.dispatch("DemoStore/setUpdatedStatus", this.storeAllDataForStatus[this.selectedChannel][this.selectedCategory.key])
			} else {
				this.$store.dispatch("DemoStore/setUpdatedStatus", '')
			}
		},
		dateRange: {
			handler() {
				this.getAllStatusByApi();
			},
			deep: true,
		}
	},
	created() {
		// Create Platforms dropdown
		if (localStorage.viewPlatformAndCategoryData) {
			JSON.parse(localStorage.viewPlatformAndCategoryData).platform.forEach(
				(pf) => {
					this.channelsList.push(pf.platform_name);
				}
			);
			this.selectedChannel = this.channelsList[0];

			this.categoriesList = JSON.parse(
				localStorage.viewPlatformAndCategoryData
			).reviews;
			this.selectedCategory = this.categoriesList[this.selectedChannel][0];

			const localProductList = JSON.parse(localStorage.demo_voc_product_list);

			this.productsList = {
				...this.productsList,
				...localProductList,
			};
			Object.values(this.productsList).forEach((platform) => {
				Object.values(platform).forEach((category) => {
					category.unshift({ name: "All" });
				});
			});
			this.showNoDataImgForUser = false
		}else{
			this.showNoDataImgForUser = true
		}
	},
	computed: {
		...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
		visiblePages() {
			const totalPages = this.numberOfPages;
			const currentPage = this.currentPage;
			let pages = [];

			if (totalPages <= 7) {
				for (let i = 1; i <= totalPages; i++) {
					pages.push(i);
				}
			} else {
				pages.push(1);
				if (currentPage > 4) {
					pages.push(null);
				}

				const startPage = Math.max(2, currentPage - 2);
				const endPage = Math.min(totalPages - 1, currentPage + 2);

				for (let i = startPage; i <= endPage; i++) {
					pages.push(i);
				}

				if (currentPage < totalPages - 3) {
					pages.push(null);
				}
				pages.push(totalPages);
			}
			return pages;
		},
	},
	methods: {
		...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
		paginate() {
			if (this.rawData.length % this.columnsPerPage > 5) {
				this.numberOfPages = Math.ceil(
					this.rawData.length / this.columnsPerPage
				);
			} else
				this.numberOfPages = Math.floor(
					this.rawData.length / this.columnsPerPage
				);

			if (this.numberOfPages > 1) {
				for (let i = 1; i <= this.numberOfPages; i++) {
					this.pagesArr.push(i);
				}
			}

			this.setCurrentPageData();
		},
		setPreviousPage() {
			this.currentPage--;
			this.setCurrentPageData();
		},
		setNextPage() {
			this.currentPage++;
			this.setCurrentPageData();
		},
		setCurrentPageData(pageNum) {
			if (pageNum) this.currentPage = pageNum;

			let previousPage = this.currentPage - 1;

			if (this.numberOfPages === 0) {
				this.chartData = this.rawData;
				if (this.rawData.length === 1) {
					this.chartData.unshift(["Phrases"]);
				}
			} else {
				if (this.currentPage === this.pagesArr[this.pagesArr.length - 1]) {
					this.chartData = this.rawData.slice(
						previousPage * 20,
						this.rawData.length
					);
				} else {
					this.chartData = this.rawData.slice(
						previousPage * 20,
						this.currentPage * 20
					);
				}
			}
		},
		getAllStatusByApi() {
			let self = this;
			self.loaderStatus = true;
			const url = 'api/v2/sensespiderstatus'
			let payload = {
				timestamp: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
				feature: 'pincode'
			}
			self.$http.post(url, payload).then((response) => {
				self.storeAllDataForStatus = response.body.data;
				if (Object.keys(self.storeAllDataForStatus).length) {
					self.$store.dispatch("DemoStore/setUpdatedStatus", self.storeAllDataForStatus[self.selectedChannel][self.selectedCategory.key])
				} else {
					self.$store.dispatch("DemoStore/setUpdatedStatus", '');
				}
				self.loaderStatus = false;
			}).catch(err => {
				console.log(err);
				self.loaderStatus = false
			})
		},
		updateChannel() {
			this.selectedCategory = this.categoriesList[this.selectedChannel][0];
			// this.selectedProducts = []
		},
		updateCategory() {
			this.selectedProducts = [];
			// if (Object.keys(this.storeAllDataForStatus).length) {
			// 	this.$store.dispatch("DemoStore/setUpdatedStatus", this.storeAllDataForStatus[this.selectedChannel][this.selectedCategory.key])
			// }
		},
		selectProduct(selectedOption) {
			if (selectedOption.name === "All") {
				this.selectedProducts =
					this.productsList[this.selectedChannel][this.selectedCategory.key];
			} else return;
		},
		removeProduct(removedOption) {
			if (removedOption.name === "All") {
				this.selectedProducts = [];
			} else return;
		},
		onChartReady() {
			this.loader = false;
		},
		updateSelectedLabels(value) {
			return value.replace('_', ' ')
		},
		getWordTreeData() {
			this.updateChannel();
			// Validation for required fields
			if (!this.selectedProducts.length) {
				this.$bvToast.toast(`Please select at least one product.`, {
					title: "Weavr Sense",
					variant: "danger",
					toaster: "b-toaster-top-right",
					autoHideDelay: 3000,
				});
				return;
			}
			if (!this.selectedKeyword) {
				this.$bvToast.toast(`Please provide a keyword.`, {
					title: "Weavr Sense",
					variant: "danger",
					toaster: "b-toaster-top-right",
					autoHideDelay: 3000,
				});
				return;
			}

			// Reset data fields
			this.chartData = [];
			this.rawData = [];
			this.pagesArr = [];
			this.chartOptions.wordtree.word = this.selectedKeyword;
			this.loader = true;

			// Payload preparation & data fetching
			const url = "/api/v2/phrase_analyzer";
			const payload = {
				client: this.client,
				channel: [],
				start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
				end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
				keyword: this.selectedKeyword,
				least_rating: this.leastRating,
				max_rating: this.maxRating,
				products: [],
				category: this.selectedCategory.key,
			};
			this.selectedProducts.filter((eachProduct) =>
				payload.products.push(eachProduct.name)
			);
			this.selectedChannel === "All"
				? (payload.channel = this.channelsList)
				: payload.channel.push(this.selectedChannel);

			this.$http
				.post(url, payload)
				.then((res) => {
					this.rawData = res.data.data;
					if (!this.rawData.length) {
						this.loader = false;
						return;
					}
					this.paginate();
				})
				.catch((err) => {
					console.log(err);
					this.$bvToast.toast(`Error: Check console for detailed info.`, {
						title: "Weavr Sense",
						variant: "danger",
						toaster: "b-toaster-top-right",
						autoHideDelay: 3000,
					});
					this.loader = false;
				});
		},
	},
};
</script>
<style scoped>
.pagination-button {
	padding-inline: 6px;
	padding-block: 2px;
	cursor: pointer;
	border: 1px solid var(--primary_brand-80);
	border-radius: 4px;
	min-width: 30px;
	text-align: center;
	color: var(--primary_brand);
	background-color: white;
}

.pagination-button:disabled {
	background-color: rgb(198, 200, 202);
	cursor: not-allowed;
	color: white;
	font-weight: 600;
	border: 1px solid rgb(198, 200, 202);
}

.pagination-button.active {
	color: white;
	background-color: var(--primary_brand-80);
	font-weight: 600;
}

.card {
	border-radius: 0.7rem !important;
	border: none !important;
	margin-bottom: 1rem;
}

.form-control {
	border-radius: 5px !important;
	padding: 6px !important;
	font-size: 12px !important;
	height: 35px !important;
	border: 1px solid var(--base_color-40) !important;
}

.date-range-control {
	border-radius: 5px !important;
	padding: 5px 6px !important;
	font-size: 11px !important;
	height: 35px !important;
	border: 0px !important;
}

.customSelect :focus {
	background: var(--base_color-5);
	color: var(--primary_brand-60);
	border: 1px solid var(--primary_brand-60) !important;
	outline: none;
	box-shadow: none;
	font-weight: 600;
}

.customMultiselect {
	width: 300px;
	max-width: 300px;
}

@media (max-width: 1650px) {
	.customMultiselect {
		width: 250px;
		max-width: 250px;
	}
}

button.primarycolor {
	background: var(--primary_brand);
	font-family: "Poppins", sans-serif;
	color: white;
	padding: 5px 25px;
	border-radius: 6px;
	font-weight: bold;
	font-size: 14px;
}

button.primarycolor:hover {
	color: white;
	background: var(--primary_brand-80);
}

.navigationButtonSmall {
	height: 35px;
	border: none;
	margin: 0;
	background: var(--accent_color);
	color: white;
	border-radius: 5px;
	font-size: 12px;
	font-weight: bold;
	padding: 0px 10px;
	letter-spacing: 0.2px;
	font-family: "poppins";
}

.navigationButtonSmall:hover {
	background: var(--accent_color-80);
}

.inner-row:not(:last-child) {
	border-bottom: 1px solid var(--base_color-20) !important;
}

.inner-cols {
	width: 10% !important;
}

@media (max-width: 1450px) {
	.inner-cols {
		width: 12% !important;
	}
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.customMultiselect .multiselect__placeholder {
	margin-bottom: 6px !important;
	padding: 0px !important;
	color: var(--primary_brand-40) !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__tags {
	border: 1px solid var(--base_color-40) !important;
	padding-top: 6px !important;
	min-height: 35px !important;
	max-height: 36px !important;
	overflow-y: auto;
	overflow-x: hidden;
	font-family: "poppins";
}

.customMultiselect .multiselect__input {
	border: var(--base_color-20) !important;
	height: 30px !important;
}

.customMultiselect .multiselect__input:focus {
	outline: none !important;
}

.customMultiselect .multiselect__select {
	min-height: 35px !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
	top: 56% !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__tag {
	background: var(--primary_brand-80) !important;
	margin-bottom: 0px !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
	color: #fff !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
	border: 1px solid var(--base_color-40) !important;
	border-top: none !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
	background: var(--red) !important;
	color: var(--white) !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
	background: var(--base_color-20) !important;
	color: var(--primary_brand-80) !important;
	font-family: "poppins";
}

.customMultiselect .multiselect__element {
	color: var(--primary_brand-80) !important;
	border-bottom: 1px solid var(--base_color-20);
	font-family: "poppins";
}

.customMultiselect .multiselect__option--group {
	background-color: #44777a !important;
	color: white !important;
	font-size: 16px;
}

.customMultiselect .multiselect__option--highlight::after {
	font-size: 10px !important;
	padding-inline: 6px !important;
}

/* width */
.customMultiselect ::-webkit-scrollbar {
	width: 10px;
	border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
	background: var(--base_color-20);
	border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
	background: var(--base_color-80);
	border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
	background: var(--base_color);
}

button.primarycolor:hover {
	color: white;
	background: var(--primary_brand-80);
}

/* .modal-title {
	font-weight: 400 !important;
	font-family: "poppins" !important;
	border-bottom: 1px solid #D5D5D5 !important;
	padding-bottom: 15px;
	color: #5E5E5E !important;
	font-size: 16px;
}

.modal-header {
	background: var(--primary_brand-20) !important;
	color: var(--base_color) !important;
	border: none !important;
	font-family: "poppins" !important;
	border-radius: 5px 0px 0px 0px !important;
	word-break: break-all;
}

.modal-header .close {
	color: black !important;
	text-shadow: none !important;
	position: absolute !important;
	top: -2px !important;
	right: -6px !important;
	font-size: 30px !important;
	background: var(--primary_brand-10) !important;
	opacity: inherit !important;
	padding: 5px 10px !important;
	border-radius: 25px !important;
} */

.containerOverflowClass {
	overflow-x: visible !important;
}
</style>
